<script>
    import { onMount } from "svelte";
    import { navigate } from "svelte-routing";
    import feedStore from '../stores/feed'
    import FeedSource from '../components/FeedSourcesComponent/FeedSource.svelte';

    // $: roleValue = $feedStore.roleValue

    let sources = {};
    let newSourceUrl = '';
    let sourceLookup = {};
    let binSubscriptionID;
    let tagSourceMap = {};
    let tagFilter = null;

    let feedSources = [];
    $: {
        if (!tagFilter) {
            feedSources = Object.values(sources);
        } else {
            feedSources = tagSourceMap[tagFilter].map(id => sources[id])
        }
    }
    
    $: tagOptions = Object.keys(tagSourceMap).sort();

    function isSubscribedToSource(sourceHash) {
        return sourceLookup[sourceHash];
    }

    $: [sourceLookup, binSubscriptionID] = $feedStore.subscriptions.reduce((acc, subscription) => {
        const { subscription: sub } = subscription;
        const { feeds = '' } = sub;
        (feeds || '').split(',').forEach(_feed => acc[0][_feed] = sub.id);
        if (sub.shortCode === '!bin') {
            acc[1] = sub.id;
        }
        return acc;
    }, [{}, binSubscriptionID])

    function getSources() {
        fetch('/api/v1/sources/get')
        .then(data => data.json())
        .then(response => {
            const { status, sources } = response;
            if (status !== 200) {
                navigate('/');
                return;
            }

            feedSources = sources;
        })
    }

    async function getConnectionSources() {
        const response = await fetch('/api/v1/connection-sources/get');
        ({ sources, tagSourceMap } = await response.json());
    }

    function getConnectionSourcesMock() {
        const response = {
            "sources": {
                "15": {
                    "feedSourceID": 15, 
                    "hashID": "26c140a13b55b7439524d5afc68e3bb4", 
                    "tags": ['#orange', '#crypto'], 
                    "title": 'Larry Ferlazzo - EduBlog', 
                    "url": "https://larryferlazzo.edublogs.org/feed/", 
                    "userIDs": [
                        4
                    ]
                }, 
                "16": {
                    "feedSourceID": 16, 
                    "hashID": "6a3084b9c54cfb89d9381ef99e98b2ff", 
                    "tags": [], 
                    "title": null, 
                    "url": "https://feeds.feedburner.com/tedblog", 
                    "userIDs": [
                        4
                    ]
                }, 
                "336": {
                    "feedSourceID": 336, 
                    "hashID": "c03b233afbccae8dee0bf28c25c9a63d", 
                    "tags": ['#crypto', '#web3'], 
                    "title": null, 
                    "url": "https://bulletproofscreenwriting.tv/feed/", 
                    "userIDs": [
                        9
                    ]
                }
            }, 
                "status": 200, 
                "success": true, 
                "tagSourceMap": {'#crypto': [15, 336], '#web3': [336], '#orange': [15]}
            }
        sources = response.sources;
        // feedSources = Object.values(response.sources);
        tagSourceMap = response.tagSourceMap;
        // tagOptions = Object.keys(response.tagSourceMap);
    }

    function addNewSource() {
        if (!newSourceUrl) return;
        fetch('/api/v1/sources/add', {
            method: 'POST',
            body: JSON.stringify({
                url: newSourceUrl,
            }),
        })
        .then(data => data.json())
        .then(response => {
            const { feedSource } = response;
            if (feedSource) {
                feedSources.push(feedSource);
                newSourceUrl = '';
            }
        })
    }

    function subscribeToSource(feedSource) {
        const {
            hashID: feedSourceHashID,
            feedSourceID,
        } = feedSource
        
        let subscriptionID = isSubscribedToSource(feedSourceHashID);

        if (!subscriptionID) {
            subscriptionID = binSubscriptionID;
        }

        if (!subscriptionID) return;

        fetch('/api/v1/sources/subscribe', {
            method: 'POST',
            body: JSON.stringify({ feedSourceHashID, feedSourceID }),
        })
        .then(data => data.json())
        .then(response => {
            const { success, feeds } = response;

            if (success) {
                feedStore.updateSubscriptionFeeds({
                    subscriptionID,
                    feeds: feeds.join(',')
                });
            }
            
        })
    }

    onMount(() => {
        getConnectionSources();
        // if (roleValue && roleValue < 1) {
        //     console.log('curator');
        //     getSources();
        // } else {
        //     console.log('pleb')
        //     getConnectionSources();
        // }
        // getSourcesMock();
        // getConnectionSourcesMock();
    });

    function chooseTagOption(tagOption) {
        tagFilter = tagOption;
    }

    function showAllSources() {
        tagFilter = null;
    }
</script>

<main>
    <form id="new-source-form">
        <input bind:value={newSourceUrl} class="input" type="text" name="source-url" autocomplete="off" placeholder="url" data-required="true" required />
        <button on:click|preventDefault="{addNewSource}" type="submit" form="new-source-form" class="primary-green">
            New Source
        </button>
    </form>
    <div class="tag-option-container">
        <div class="tag-option" on:click={() => showAllSources()}>#All</div>
        {#each tagOptions as tag}
            <div class="tag-option" on:click={chooseTagOption(tag)}>{tag}</div>
        {/each}
    </div>
    {#each feedSources as feedSource}
        <FeedSource 
            feedSource={feedSource}
            tagOptions={tagOptions}
            subscribeToSource={subscribeToSource}
            sourceLookup={sourceLookup}
        />
    {/each}
</main>

<style>
    .tag-option-container {
        margin: 16px 0;
        color: rgb(42, 126, 25);
        display: flex;
    }
    .tag-option {
        margin-right: 12px;
        cursor: pointer;
    }
</style>